const UnitConfigurationConstants = {
  type: [{
    id: 1,
    header: 'WEIGHT',
    allowedValues: {
      1: 'kilograms',
      2: 'grams',
      3: 'centigrams',
      4: 'milligrams',
    },
  },
  {
    id: 2,
    header: 'VOLUME',
    allowedValues: {
      1: 'Cubic Feet',
      2: 'Cubic meter',
      3: 'Cubic centimeter',
      4: 'Cubic millimeter',
    },
  },
  {
    id: 3,
    header: 'CURRENCY',
    allowedValues: {
      1: 'Indian Rupees',
      2: 'Singapore Dollars',
    },
  }],
  allowedTypes: [1, 2, 3],
  defaultValue: {
    units: [{
      unit_type: 1,
      value: 1,
    },
    {
      unit_type: 2,
      value: 1,
    },
    {
      unit_type: 3,
      value: 1,
    }],
  },
};

module.exports = { UnitConfigurationConstants };
